module.exports = __webpack_public_path__ + "static/media/reporte_icfes.01e262b7.xlsx";